import { Period } from '@app/domain/Period'

export class OpeningHours {
    constructor(
        public days: OpeningHoursDay[]
    ) { }
}

export class OpeningHoursDay {
    constructor(
        public dayOfWeek: number,
        public periods: Period[]
    ) { }
}
